import { useEffect, useState, useMemo } from "react";
import FileList from "@/components/files/fileList";
import FolderTree from "@/components/files/folderTree";
import { Grid, List } from "@mui/material";
import { useTranslation } from "react-i18next";
import styles from "@/components/files/fileExplorer.module.css";
import { InputWithRef } from "@/components/forms/inputsWithRef/inputWithRef";

interface Props {
  subjectId?: string;
  onResetQuery?: any;
  showNewFiles?: boolean;
}

export default function FileExplorer(props: Props) {
  const [folderId, setFolderId] = useState<string>("");
  const [folderName, setFolderName] = useState<string>("");
  const [query, setQuery] = useState<string>("");
  const [updateFolder, setUpdateFolder] = useState<number>(0);
  const { t } = useTranslation();

  /*eslint-disable */
  const [fileId, setFileId] = useState<string>("");
  /*eslint-enable */

  const handleFolderInfos = (id: string, name: string) => {
    setFolderId(id);
    setFolderName(name);
  };

  useEffect(() => {
    resetQuery();
  }, [folderId]);

  const capitalizeFirstLetter = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const fileListHeading = useMemo(() => {
    if (query) {
      return `${t("search_documents_for", { query })}`;
    }
    if (folderName) {
      return `${t("documents")} - ${
        folderName === "Berichte von kaer"
          ? t("reports_from_kaer")
          : capitalizeFirstLetter(folderName)
      }`;
    }
    if (props.showNewFiles) {
      return t("new_files");
    }
    return t("documents");
  }, [query, folderName, props.showNewFiles, t]);

  const resetQuery = () => {
    setQuery("");
  };

  const folderUpdate = () => {
    setUpdateFolder((prev) => prev + 1);
  };

  return (
    <Grid container className={styles.container}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container component={List} className={styles.container}>
          <FolderTree
            simpleFolderView={true}
            subjectId={props.subjectId}
            folderId={folderId}
            onClickHandler={(id: string, name: string) =>
              handleFolderInfos(id, name)
            }
            source="document"
            moveFolderSource={[]}
            style={folderTreeStyle}
            heading="Ordner"
            updateFolder={updateFolder}
            query={query}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
        <InputWithRef
          name={"search"}
          value={query}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setQuery(e.target.value)
          }
          placeholder={t("search_files")}
          clearable={true}
          onClear={() => resetQuery()}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} className={styles.fileListWrapper}>
        {(folderId || query || props.showNewFiles) && (
          <Grid container className={styles.flexContainer}>
            <Grid item component={"h3"} className={styles.heading}>
              {fileListHeading}
            </Grid>
            <FileList
              subjectId={props.subjectId}
              folderId={query ? undefined : folderId}
              folderName={folderName}
              onClickHandler={(id: any) => setFileId(id)}
              query={query}
              addedSinceLastLogin={props.showNewFiles && !folderId && !query}
              folderUpdate={folderUpdate}
            />
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

const folderTreeStyle = {
  width: "40%",
} as React.CSSProperties;
